import React from 'react';
import DownloadIcon from '@mui/icons-material/Download';
import { hasHomepageIntroContent } from '../../utils/homepageIntroUtils';

const HomepageIntro = ({ intro }) => {
  if (!hasHomepageIntroContent(intro)) {
    return null;
  }

  const downloadFile = intro.downloadFile?.trim();
  const downloadLabel = (intro.downloadLabel?.trim() || downloadFile || '').trim();
  const downloadHref = downloadFile
    ? `/${encodeURI(downloadFile).replace(/#/g, '%23').replace(/\?/g, '%3F')}`
    : '';

  return (
    <section className="promo homepage-intro">
      <div className="container">
        {intro.title?.trim() && (
          <h3 className="promo-title">{intro.title.trim()}</h3>
        )}
        {downloadFile && (
          <div className="homepage-intro-download">
            <a
              href={downloadHref}
              download={downloadFile}
              className="homepage-intro-download__link"
            >
              <DownloadIcon fontSize="small" />
              <span>{downloadLabel}</span>
            </a>
          </div>
        )}
        {(intro.time?.trim() || intro.eventText?.trim()) && (
          <div className="promo-highlight">
            {intro.time?.trim() && (
              <span className="promo-highlight__time">{intro.time.trim()}</span>
            )}
            {intro.eventText?.trim() && (
              <span className="promo-highlight__event">{intro.eventText.trim()}</span>
            )}
          </div>
        )}
      </div>
    </section>
  );
};

export default HomepageIntro;
